import { SvgInfo } from '@wix/document-services-types';
import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
import { DependencyToken } from '../dependencies';

export class ExternalResolvedDataHandler extends AbstractExternalAPIHandler {
  #hasUriProperty(data: unknown): data is { uri: string } {
    return data !== null && typeof data === 'object' && 'uri' in data;
  }

  getVectorArtResolvedData(data: unknown): SvgInfo | undefined {
    if (!this.#hasUriProperty(data)) {
      return undefined;
    }

    const getSvgInfo = this.dependenciesContributor.get(
      DependencyToken.DM_SVG_INFO_GET,
    );

    return getSvgInfo(data.uri);
  }
}
